export default function buildTableQuery(
  modalFields,
  options = { withNextPage: false }
) {
  const {
    page,
    sortBy,
    sortDirection,
    searchQuery,
    searchType,
    searchStatus,
    groupByBranch,
  } = modalFields;
  if (!modalFields) return '';

  let query = '';

  if (options.page !== undefined) {
    query += `&page=${options.page}`;
  } else if (page && options.withNextPage) {
    query += `&page=${page + 1}`;
  }

  if (sortBy && sortDirection) {
    query += `&order_by=${sortBy}&order_direction=${sortDirection}`;
  }

  if (searchQuery) {
    query += `&search_query=${searchQuery}`;
    if (searchType) {
      query += `&search_type=${searchType}`;
    }
  }

  if (searchStatus) {
    query += `&status_filter=${searchStatus}`;
  }

  if (groupByBranch) {
    query += `&group_by_branch=${groupByBranch}`;
  }

  return query;
}
